import { render, staticRenderFns } from "./AllCountryKeyServiceGreetings.vue?vue&type=template&id=4ecfa498&scoped=true&"
import script from "./AllCountryKeyServiceGreetings.vue?vue&type=script&lang=js&"
export * from "./AllCountryKeyServiceGreetings.vue?vue&type=script&lang=js&"
import style0 from "./AllCountryKeyServiceGreetings.vue?vue&type=style&index=0&id=4ecfa498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecfa498",
  null
  
)

export default component.exports